/* Accurized resources - click-to-load video.

   No Vimeo script and no iframe until someone actually asks for a video. Three
   cards would otherwise pull in three players on every page load, and almost
   nobody plays all three. The poster is a plain <button> so it is keyboard
   reachable and announces itself; on click it is replaced by the iframe with
   autoplay, so the click that opened it is also the click that starts it. */
(function () {
    'use strict';

    function mount(btn) {
        var id = btn.getAttribute('data-vimeo');
        var title = btn.getAttribute('data-title') || 'Video';
        if (!id) return;

        var frame = document.createElement('div');
        frame.className = 'dp-res-frame';

        var iframe = document.createElement('iframe');
        iframe.src = 'https://player.vimeo.com/video/' + encodeURIComponent(id) +
                     '?autoplay=1&title=0&byline=0&portrait=0&dnt=1';
        iframe.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture');
        iframe.setAttribute('allowfullscreen', '');
        iframe.setAttribute('title', title);
        iframe.setAttribute('loading', 'lazy');

        frame.appendChild(iframe);
        btn.parentNode.replaceChild(frame, btn);
        iframe.focus();
    }

    function boot(root) {
        Array.prototype.forEach.call(
            (root || document).querySelectorAll('[data-vimeo]'),
            function (btn) {
                if (btn.dataset.dpBound === '1') return;
                btn.dataset.dpBound = '1';
                btn.addEventListener('click', function () { mount(btn); });
            }
        );
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () { boot(); });
    } else {
        boot();
    }

    document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
